module.exports = __webpack_public_path__ + "img/doctor_headimg.ec8fc2c7.png";